import { render, staticRenderFns } from "./PhPhone.vue?vue&type=template&id=3e7fc920"
import script from "./PhPhone.vue?vue&type=script&lang=js"
export * from "./PhPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports